import type { OrderConfig } from './order.types';

export const orderConfig: OrderConfig = {
  paths: {
    basket: {
      default: '/warenkorb',
      page: 'BASKET',
    },
    login: {
      default: '/kasse/registrieren',
      page: 'LOGIN_PAGE',
    },
    delivery: {
      default: '/kasse/lieferservice',
      page: 'DELIVERY_PAGE',
    },
    changeDelivery: {
      default: '/kasse/lieferservice-aendern',
      page: 'CHANGE_DELIVERY_PAGE',
    },
    payment: {
      default: '/kasse/zahlung',
      page: 'PAYMENT_PAGE',
    },
    changePayment: {
      default: '/kasse/zahlung-aendern',
      page: 'CHANGE_PAYMENT_PAGE',
    },
    paymentprotection: {
      default: '/kasse/ratenschutz',
      page: 'INSURANCE_AD',
    },
    paymentprotectionupdate: {
      default: '/kasse/ratenschutz-aktualisierung',
      page: 'UPGRADE_INSURANCE_AD',
    },
    delayedPayment: {
      default: '/kasse/zahlpause',
      page: 'DELAYED_PAYMENT_AD',
    },
    premium: {
      default: '/kasse/premium',
      page: 'PREMIUM_AD',
    },
    checkandorder: {
      default: '/kasse',
      page: 'CHECK_AND_ORDER',
    },
    orderconfirmation: {
      default: '/kasse/auftrag',
      page: 'ORDER_CONFIRMATION',
    },
    noOrder: {
      default: '/kasse/hinweis',
      page: 'NO_ORDER',
    },
    afterPayment: {
      default: '/kasse/bezahlt/',
    },
    creditCheck: {
      default: '/credit-check',
    },
    myAccountBase: {
      default: '/mein-konto',
      'fr-CH': '/mon-compte',
      'nl-NL': '/mijn-account',
    },
    myAccountOverview: {
      default: '/mein-konto/uebersicht',
      'fr-CH': '/mon-compte/apercu',
      'nl-NL': '/mijn-account/overzicht',
    },
    myAccountPersonalData: {
      default: '/mein-konto/meine-persoenlichen-daten',
      'fr-CH': '/mon-compte/mes-donnees-personnelles',
      'nl-NL': '/mijn-account/mijn-persoonlijke-gegevens',
    },
    myAccountOrders: {
      default: '/mein-konto/meine-bestellungen-und-lieferungen',
      'fr-CH': '/mon-compte/mes-commandes-et-livraisons',
      'nl-NL': '/mijn-account/mijn-bestellingen-en-leveringen',
    },
    myAccountBookings: {
      default: '/mein-konto/meine-buchungen',
      'fr-CH': '/mon-compte/mes-reservations',
      'nl-NL': '/mijn-account/mijn-boekingen',
    },
    myAccountInvoices: {
      default: '/mein-konto/meine-rechnungen',
      'fr-CH': '/mon-compte/mes-factures',
      'nl-NL': '/mijn-account/mijn-facturen',
    },
    myAccountAddresses: {
      default: '/mein-konto/mein-adressbuch',
      'fr-CH': '/mon-compte/mon-carnet-d-adresses',
      'nl-NL': '/mijn-account/mijn-adresboek',
    },
    myAccountPayback: {
      default: '/mein-konto/payback',
      // 'fr-CH': '/mon-compte/payback',
      // 'nl-NL': '/mijn-account/payback',
    },
    myAccountPaymentsDates: {
      default: '/mein-konto/meine-zahltermine',
      // 'fr-CH': '/mon-compte/mes-dates-de-paiement',
      // 'nl-NL': '/mijn-account/mijn-betalingsdata',
    },
    verify: {
      default: '/verify',
    },
    wishlist: {
      default: '/merkzettel',
    },
    paylink: {
      default: '/paylink',
      'fr-CH': '/fr/paylink',
    },
    paylinkSuccess: {
      // this is to turn off geo country layer on paylink success page
      default: '/paylink/returning-success/',
      'fr-CH': '/fr/paylink/returning-success/',
    },
    paylinkReturningFromPayPage: {
      // this is to turn off geo country layer on paylink credit card callback page
      default: '/paylink/returningfrompaypage',
      'fr-CH': '/fr/paylink/returningfrompaypage',
    },
    paylinkReturn: {
      // this is to turn off geo country layer on paylink PayPal callback page
      default: '/paylink/return/',
      'fr-CH': '/fr/paylink/return/',
    },
    paylinkData: {
      // this is to turn off geo country layer on paylink initialization page
      default: '/paylink/data/',
      'fr-CH': '/fr/paylink/data/',
    },
  },
  supportedPaths: {
    myAccountBookings: false,
    myAccountOrders: false,
    myAccountOverview: false,
    myAccountInvoices: false,
    myAccountPaymentsDates: false,
    myAccountPayback: false,
    myAccountAddresses: false,
  },
  externalUrls: {
    agb: {
      default: '/service-hilfe/ueber-uns/agb/',
      'fr-CH': '/fr/aide-service/qui-sommes-nous/cgv',
      'nl-NL': '/special/algemene-voorwaarden',
    },
    revocation: {
      default: '/service-hilfe/ueber-uns/agb/',
      'fr-CH': '/fr/aide-service/qui-sommes-nous/cgv',
      'nl-NL': '/special/herroepingsrecht',
    },
    dataProtection: {
      default: '/service-hilfe/ueber-uns/datenschutz/datenschutzhinweis',
      'fr-CH': '/aide-service/qui-sommes-nous/protection-des-donnees',
      'nl-NL': '/special/herroepingsrecht',
    },
    joe: {
      default: 'https://www.joe-club.at/registrieren',
    },
  },
  seals: {
    ehi: {
      enabled: false,
      url: '',
    },
    trustedShops: {
      enabled: false,
      url: '',
    },
    staatswappen: {
      enabled: false,
      url: '',
    },
    handelsverband: {
      enabled: false,
      url: '',
    },
    ecommerce: {
      enabled: false,
      url: '',
    },
    oeonline: {
      enabled: false,
      url: '',
    },
    dqs: {
      enabled: false,
      url: '',
    },
  },
  premium: {
    enabled: false,
  },
  joe: {
    enabled: false,
  },
  assets: {
    seals: {
      getSealImage: ({ language, sealName }) => {
        switch (sealName) {
          case 'trustedShops':
            return `https://bilder.baur.de/i/empiriecom/io/${language}/trustedshops.jpg`;
          case 'ehi':
            return `https://bilder.baur.de/i/empiriecom/io/${language}/siegel_ehi.png`;
          case 'staatswappen':
            return `https://bilder.baur.de/i/empiriecom/io/${language}/staatswappen.png`;
          case 'handelsverband':
            return `https://bilder.baur.de/i/empiriecom/io/${language}/handelsverband.jpg`;
          case 'ecommerce':
            return `https://bilder.baur.de/i/empiriecom/io/${language}/ecommerce.jpg`;
          case 'oeonline':
            return `https://bilder.baur.de/i/empiriecom/io/${language}/oeonline.png`;
          case 'dqs':
            return `https://bilder.baur.de/i/empiriecom/io/${language}/ISO-14001-D.png`;
          default:
            return '';
        }
      },
    },
    premium: {
      getPremiumImage: ({ device }) =>
        `https://bilder.universal.at/empiriecom/io/universalat/de/BS3_CheckOut_${device}.jpg`,
    },
    gifs: {
      success: {
        url: 'https://bilder.baur.de/i/empiriecom/io/de/thank_you_1_transparent.gif',
      },
    },
  },
  layers: {
    servicelayer: {
      default: '',
    },
  },
  hasCo2Compensation: true,
  hasFlexikontoAdvantageClub: false,
  payment: {
    americanExpress: false,
    clickToPay: false,
  },
  paylink: {
    enabled: true,
    paymentMethods: ['paypal', 'mastercard', 'visa', 'diners', 'discover'],
    respectTypeFromApi: false,
  },
  payback: {
    enabled: false,
  },
  accountInformation: {
    bankTransferEnabled: true,
    bicAvailable: true,
  },
  recommendations: {
    wishlist: {
      similarProducts: {
        isEnabled: true,
        type: 'prudsysProductsSimilar',
      },
    },
  },
  aplusIdentifier: 'uuid',
  bankInformation: {
    companyName: 'Quelle GmbH',
    bankName: 'Commerzbank AG',
    iban: 'DE58 7804 0081 0788 0990 00',
    bic: 'COBADEFF780',
  },
  customerInvoices: {
    enableTabsMode: true,
  },
  loginRegisterVariant: 'control',
  addressValidation: {
    zipCode: {
      length: 5,
    },
  },
};
